import { render, staticRenderFns } from "./BookingProcessSummary.vue?vue&type=template&id=527f2e93"
import script from "./BookingProcessSummary.vue?vue&type=script&lang=ts"
export * from "./BookingProcessSummary.vue?vue&type=script&lang=ts"
import style0 from "./BookingProcessSummary.vue?vue&type=style&index=0&id=527f2e93&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports